module.exports = __webpack_public_path__ + "img/swiper4.1f294992.png";